export enum MessageTypeEnum {
  TEXT = 'text',
  IMAGE = 'image',
  FILE = 'file',
  BUTTON = 'button',
  VIDEO = 'video',
  LINK = 'link',
  PROGRESS_BAR = 'progress_bar',
  START_CONVERSATION = 'start-conversation',
  SEEN_CONVERSATION = 'seen-conversation',
  RESTART_CONVERSATION = 'restart-conversation',
  TEXT_INPUT = 'text_input',
  TEXT_INPUT_RESPONSE = 'text_input_response',
  POSTBACK = 'postback',
  CAROUSEL = 'carousel',
}
